import React from 'react';
import withStyles from '@mui/styles/withStyles';

const styles = theme => ({
    mainDiv:{
        width:'70%',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
        borderRadius:'8px',
        display:'flex',
        flexDirection:'column',
        justifyContent:'space-around',
        padding: '10px 10px',
        marginTop:'10px',
        alignSelf:'center',
        border: '1px solid #e4e8ed',
        backgroundColor:'#fff',
        [theme.breakpoints.between('xs','md')]: {
            width:'calc(100% - 20px)'
		}
    },

    resDetail:{
        color: '#6B7C94',
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 'bold',
        letterSpacing: '0.025em',
        fontSize: '20px',
        textAlign: 'center',
    },

    input:{
        display: 'block',
        margin: '10px 0 20px 0',
        padding: '10px 14px',
        fontFamily: "'Cairo', sans-serif",
        fontSize: '1em',
        border: 0,
        outline: 0,
        borderRadius: '4px',
        backgroundColor: '#F4F6F8',
        border:'1px solid #E5E5E5',
        [theme.breakpoints.between('xs','md')]: {
            fontSize:'0.8em'
		}
    },

    option:{
        fontSize:'16px'
    }
})

class DurationSection2 extends React.Component {

    render() {
        const { renewOptions, onChangeHandle, month, classes } = this.props;
    return(
        <div className={classes.mainDiv}>
            <span className={classes.resDetail}>Select Duration</span>
            <select className={classes.input} value={month} id='month' onChange={onChangeHandle}>
                {/* <option value="">Select Duration</option> */}
                {React.Children.toArray(renewOptions.map(v=> <option className={classes.option} value={v.id}>{v.label}</option>))}
            </select>
        </div>
    )}
}

export default withStyles(styles)(DurationSection2);